import styled, { CSSObject } from 'styled-components';
import { BoxWrapperPropsType, getSpacingStyles, SpacingPropsType } from '@/components/Box/boxHelpers';
import { media } from '@/styles/responsive';

export type ButtonGroupWrapperType = {
  gap?: string;
  mobileStretch?: boolean;
  gridTemplateColumns?: string;
} & SpacingPropsType;

export const ButtonGroupWrapper = styled.div<ButtonGroupWrapperType>`
  display: grid;
  grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns || 'repeat(2, minmax(0px, 1fr))'};
  gap: ${({ gap }) => gap};

  ${(props) => getSpacingStyles(props as BoxWrapperPropsType) as CSSObject};

  ${media.mobile`
    ${({ mobileStretch }) =>
      mobileStretch &&
      `
      grid-template-columns: repeat(1, minmax(0, 1fr));
      width: 100%;
      
      // Reverse button order, so main action button would be on top in mobile
      > *:first-child {
        order: 2;
      }
      
      > *:last-child {
        order: 1;
      }
    `};
  `}
`;
